import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getLocationsWoLoader } from "../../../redux/reducers/clinicSlice";
import { storePetDetScreenDetails } from "../../../redux/reducers/mixedSlice";
import {
  getAppointmentsByPetId,
  getPetDetailsById,
  getPetsCompliantSummary,
  getProceduresByPetIdWoLoader,
  getReminderProceduresByPetIdWoLoader,
} from "../../../redux/reducers/petSlice";
import CommonClinicPetDetails from "../../CommonScreens/CommonClinicPetDetails/CommonClinicPetDetails";
import BillingHistory from "./Billing/BillingHistory";
import MedicalHistoryNew from "./MedicalHistory/MedicalHistoryNew";
import Overview from "./Overview/Overview";
import PatientWorkbook from "./PatientWorkbook/PatientWorkbook";
import Task from "./Task/Task";

const ClinicPetDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { title, type, appointment } = location.state || {};
  const [isVideoCallEnabled, setVideoCallEnabled] = useState(false);
  const [scrollable, setScrollable] = useState(true);
  const [isEditBill, setEditBill] = useState(
    location?.state?.editBill ?? false,
  );
  const [allergyModOpen, setAllergyModOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState(
    location?.state?.bill ?? null,
  );
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.selectedTab === "billing" ? "billing" : "overView",
  );
  const [inpatientId, setInpatientId] = useState(location?.state?.inpatientId);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appointmentId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  // const getPetData = apntDet?.medicalHistory;
  // const getPereventiveData = apntDet?.prevetive;

  useEffect(() => {
    if (!location?.state?.bill) setSelectedBill(null);
    // if (appointmentId) {
    //   dispatch(getPetsCompliantSummary(appointmentId));
    // } else if (petId) {
    //   dispatch(getPetDetailsById(petId));
    // }
    if (petId) {
      dispatch(
        getProceduresByPetIdWoLoader({
          petId,
          url: `?reminderPreventive=true&page=1&itemSize=50`,
        }),
      );
      dispatch(
        getReminderProceduresByPetIdWoLoader({
          petId,
          url: `?reminderProcedure=true&page=1&itemSize=50`,
        }),
      );
    }
    dispatch(getLocationsWoLoader());
    dispatch(
      storePetDetScreenDetails({
        appointmentId: appointmentId ?? null,
        petId: appointmentId ? null : petId,
      }),
    );
  }, [location.key, appointmentId, petId, dispatch]);

  // Appointments list is only consumed by the overview UI, so load it lazily
  // when the overview tab is active. This avoids fetching it when we land
  // directly on another tab (e.g. billing).
  useEffect(() => {
    if (selectedTab === "overView" && petId) {
      dispatch(getAppointmentsByPetId(petId));
    }
  }, [selectedTab, petId, location.key, dispatch]);

  useEffect(() => {
    const {
      selectedTab: tabFromNav,
      bill,
      editBill: editBillFromNav,
    } = location.state || {};
    if (!tabFromNav) return;
    if (tabFromNav === "admissionDetails") {
      setSelectedTab((prev) =>
        prev === "admissionDetails" && !apntDet?.appointment?.inpatient
          ? "overView"
          : tabFromNav,
      );
    } else {
      setSelectedTab(tabFromNav);
      if (bill) {
        setEditBill(editBillFromNav ?? false);
        setSelectedBill(bill);
      }
    }
  }, [location, apntDet?.appointment?.inpatient]);

  return (
    <CommonClinicPetDetails
      upcomingVisible={selectedTab === "overView"}
      isVideoCallEnabled={isVideoCallEnabled}
      setVideoCallEnabled={setVideoCallEnabled}
      appointment={appointment}
      scrollable={scrollable}
      setSelectedTab={setSelectedTab}
      setInpatientId={setInpatientId}
      allergyModOpen={allergyModOpen}
      setAllergyModOpen={setAllergyModOpen}
      selectedTab={selectedTab}
      setScrollable={setScrollable}
    >
      <Grid container className="ph2">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="back-white p10 bs-margin"
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div
                  // className="ph10pv3"
                  onClick={() => setSelectedTab("overView")}
                >
                  <div
                    className={`flex-center cursor ${
                      selectedTab === "overView"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Overview
                  </div>
                </div>

                {appointment?.appoinment?.appointmentId &&
                ((apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
                  "completed" &&
                  !apntDet?.appointment?.lock) ||
                  apntDet?.appointment?.inpatient ||
                  apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
                    "consultation" ||
                  apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
                    "finalize" ||
                  (apntDet?.appointment?.appointmentType === "Virtual" &&
                    apntDet?.appointment?.appointmentStatus?.toLowerCase() ===
                      "inprogress")) ? (
                  <div
                    // className="ph10pv3"
                    onClick={() => setSelectedTab("patientWorkbook")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "patientWorkbook"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Patient Workbook
                    </div>
                  </div>
                ) : null}
                {/* {apntDet?.appointment?.inpatient && (
                  <div
                    className="ph10pv3"
                    onClick={() => setSelectedTab("admissionDetails")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "admissionDetails"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Admission Details
                    </div>
                  </div>
                )} */}

                <div
                  // className="ph10pv3"
                  onClick={() => {
                    setEditBill(false);
                    setSelectedBill(null);
                    setSelectedTab("billing");
                  }}
                >
                  <div
                    className={`flex-center cursor ${
                      selectedTab === "billing"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Billing
                  </div>
                </div>

                <div
                  // className="ph10pv3"
                  onClick={() => {
                    setSelectedTab("history");
                    setEditBill(false);
                  }}
                >
                  <div
                    className={`flex-center cursor ${
                      selectedTab === "history"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    History
                  </div>
                </div>

                {apntDet?.bundleId ? (
                  <div
                    // className="ph10pv3"
                    onClick={() => {
                      setSelectedTab("task");
                    }}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "task"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Task
                    </div>
                  </div>
                ) : null}
              </div>
            </Grid>
          </Grid>
        </Grid>
        {selectedTab === "overView" ? (
          <Overview
            // getPetData={getPetData}
            // getPereventiveData={getPereventiveData}
            appointment={appointment}
            title={title != null && title !== undefined ? title : type}
            isVideoCallEnabled={isVideoCallEnabled}
            setVideoCallEnabled={setVideoCallEnabled}
            allergyModOpen={allergyModOpen}
            setAllergyModOpen={setAllergyModOpen}
            selectedTab={selectedTab}
          />
        ) : null}
        {selectedTab === "patientWorkbook" ? (
          <PatientWorkbook
            appointment={appointment}
            setScrollable={setScrollable}
            setSelectedBill={setSelectedBill}
            setSelectedTab={setSelectedTab}
            setEditBill={setEditBill}
          />
        ) : null}
        {/* {selectedTab === "admissionDetails" ? (
          <AdmissionDetails
            inpatientId={inpatientId}
            setSelectedTab={setSelectedTab}
            setEditBill={setEditBill}
            setSelectedBill={setSelectedBill}
          />
        ) : null} */}
        <div className="mtMin20 w100Per">
          {selectedTab === "billing" ? (
            <BillingHistory
              isEditBill={isEditBill}
              setEditBill={setEditBill}
              petId={appointment?.appoinment?.petId}
              selectedBill={selectedBill}
              setSelectedBill={setSelectedBill}
              apntId={appointment?.appoinment?.appointmentId}
            />
          ) : null}
        </div>
        {selectedTab === "history" ? (
          <MedicalHistoryNew
            petId={appointment?.appoinment?.petId}
            apntId={appointment?.appoinment?.appointmentId ?? null}
          />
        ) : null}
        {/* {selectedTab === "history" ? (
          <MedicalHistory
            petId={appointment?.appoinment?.petId}
            apntId={appointment?.appoinment?.appointmentId ?? null}
          />
        ) : null} */}
        {selectedTab === "task" ? <Task /> : null}
      </Grid>
    </CommonClinicPetDetails>
  );
};

export default ClinicPetDetails;
